import PromotionsSection from './AdvertisingSection';

export default PromotionsSection;
